import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Eagerly bundle all translation JSONs into the JS module graph.
// This completely bypasses the iOS WKWebView network layer, which can take 
// ~1.5 - 2s to spin up on cold start, causing a massive UI block.
const translationFiles = import.meta.glob('../../locales/**/*.json', { eager: true });

// Convert the Vite glob object into i18next resources format.
// Expected output: { en: { translation: { ... } }, es: { translation: { ... } } }
const resources: Record<string, { translation: any }> = {};

for (const path in translationFiles) {
  // Extract the language code from the path, e.g., '../../locales/en/translation.json' -> 'en'
  const match = path.match(/\/locales\/([^/]+)\//);
  if (match && match[1]) {
    const lng = match[1];
    resources[lng] = {
      translation: (translationFiles[path] as any).default || translationFiles[path]
    };
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: [], // No persistence: always follow the system language
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
